import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import PageHead from "../component/PageHead";
import PostGrid from "../component/PostGrid";

const AuthorPosts = () => {
  const [posts, setPosts] = useState([]);
  const [author, setAuthor] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const [postsRes, userRes] = await Promise.allSettled([
          axios.get(`${process.env.REACT_APP_BASE_URL}/posts/users/${id}`),
          axios.get(`${process.env.REACT_APP_BASE_URL}/users/${id}`),
        ]);
        setPosts(postsRes.status === "fulfilled" ? postsRes.value.data || [] : []);
        setAuthor(userRes.status === "fulfilled" ? userRes.value.data : null);
      } catch (err) {
        console.log(err);
      }
      setIsLoading(false);
    };
    fetchData();
  }, [id]);

  return (
    <div className="container">
      <PageHead
        num="A"
        label="Author"
        line1={author?.name || "Author"}
        line2="published work."
      >
        {!isLoading && <span className="eyebrow num">{String(posts.length).padStart(2, "0")} posts</span>}
      </PageHead>
      <PostGrid posts={posts} isLoading={isLoading} emptyTitle="No posts from this author yet" />
    </div>
  );
};

export default AuthorPosts;
